// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import {debounce, DebouncedFunction} from 'ts-debounce';
import _ from 'underscore';

import {Permissions} from 'auth/PermissionConstants';
import {NucleotideType} from 'biojs/BioConstants';
import SearchResultRowTemplate, {SearchResultRowProps} from 'components/SearchResultRowTemplate';
import SequenceSearchMessageRowTemplate, {
  SequenceSearchMessageRowProps,
} from 'components/SequenceSearchMessageRowTemplate';
import SequenceSearchViewTemplate, {SequenceSearchViewProps} from 'components/SequenceSearchViewTemplate';
import {FolderSummary} from 'constants/FolderConstants';
import {SequenceSummary} from 'constants/SequenceConstants';
import * as keyboard from 'util/Keyboard';

export class SequenceSearchResult extends Backbone.Model {
  folder(): FolderSummary {
    return this.get('folder');
  }

  permissions(): Permissions {
    return this.get('permissions');
  }
}

class SequenceSearchResults extends Backbone.Collection<SequenceSearchResult> {
  override model!: typeof SequenceSearchResult;
  override url = '/1/api/all/search?filter=long_sequence';

  static initClass(): void {
    this.prototype.model = SequenceSearchResult;
  }

  override parse(response: {
    data: Array<SequenceSummary>;
    limit: number;
    total: number;
  }): Array<SequenceSearchResult> {
    // TODO(T1750): Callers expect `writable` key.
    return response.data.map((result: SequenceSummary) =>
      // eslint-disable-next-line no-restricted-syntax
      _.extend({writable: result.permissions.writable}, result)
    );
  }
}
SequenceSearchResults.initClass();

class DnaSequenceSearchResults extends SequenceSearchResults {
  override url = '/1/api/all/search?filter=sequence';
}
DnaSequenceSearchResults.initClass();

class RnaSequenceSearchResults extends SequenceSearchResults {
  override url = '/1/api/all/search?filter=rna_sequence';
}
RnaSequenceSearchResults.initClass();

class RnaSequenceWithoutModsSearchResults extends SequenceSearchResults {
  override url = '/1/api/all/search?filter=rna_sequence_no_mods';
}
RnaSequenceWithoutModsSearchResults.initClass();

export interface SequenceSearchViewInitializationOptions extends Backbone.ViewOptions<Backbone.Model> {
  alwaysDisplayResults?: boolean;
  clearSearchAfterClick?: boolean;
  excludeModified?: boolean;
  nucleotideType?: NucleotideType;
  selectSequence: (sequence: SequenceSearchResult) => void;
}

class SequenceSearchView extends Backbone.View<Backbone.Model> {
  alwaysDisplayResults!: boolean;
  clearSearchAfterClick!: boolean;
  _inflightXHRs!: Array<JQueryXHR> | null;
  sequenceResults!: SequenceSearchResults;

  selectSequence!: (sequence: SequenceSearchResult) => void;

  performSearch!: DebouncedFunction<(query: string) => void>;
  messageRowTemplate!: (props: SequenceSearchMessageRowProps) => string;
  resultRowTemplate!: (props: SearchResultRowProps) => string;
  template!: (props: SequenceSearchViewProps) => string;

  static initClass(): void {
    this.prototype.template = SequenceSearchViewTemplate;
    this.prototype.resultRowTemplate = SearchResultRowTemplate;
    this.prototype.messageRowTemplate = SequenceSearchMessageRowTemplate;

    this.prototype.events = {
      // @ts-expect-error: Backbone events can be either the events hash or a method returning the events hash
      // The Backbone types do not know about this.
      'input .search-input': 'handleSearchInput',
      'click .search-results a.list-group-item': 'selectResultOnClick',
      'keydown .search-input': 'selectResultOnEnter',
      'keyup .search-input': 'escapeSearch',
    };

    this.prototype.performSearch = debounce(function (query) {
      // @ts-expect-error shadows outer this
      if (this._inflightXHRs != null) {
        // @ts-expect-error shadows outer this
        this._inflightXHRs.forEach((xhr) => xhr.abort());
      }
      if (query.length > 0) {
        // @ts-expect-error shadows outer this
        this._inflightXHRs = this.fetchResults(query);
        // @ts-expect-error shadows outer this
        $.when(...Array.from(this._inflightXHRs || [])).done(() => this.updateSearchResults());
      } else {
        // @ts-expect-error shadows outer this
        this.hideSpinner();
        // @ts-expect-error shadows outer this
        this.clearSearch();
        // @ts-expect-error shadows outer this
        this._inflightXHRs = null;
      }
    }, 250);
  }

  override initialize(options: SequenceSearchViewInitializationOptions): void {
    _.defaults(options, {
      clearSearchAfterClick: true,
      alwaysDisplayResults: false,
    });

    const {selectSequence, clearSearchAfterClick, alwaysDisplayResults} = options;
    this.selectSequence = selectSequence;
    this.clearSearchAfterClick = clearSearchAfterClick!;
    this.alwaysDisplayResults = alwaysDisplayResults!;
    if (!options.nucleotideType) {
      this.sequenceResults = new SequenceSearchResults();
    } else if (options.nucleotideType === NucleotideType.DNA) {
      this.sequenceResults = new DnaSequenceSearchResults();
    } else if (options.nucleotideType === NucleotideType.RNA && options.excludeModified) {
      this.sequenceResults = new RnaSequenceWithoutModsSearchResults();
    } else if (options.nucleotideType === NucleotideType.RNA) {
      this.sequenceResults = new RnaSequenceSearchResults();
    }
    this._inflightXHRs = null;
  }

  showSpinner(): void {
    this.$('.sequence-search-wrapper .spinner').removeClass('hidden');
  }

  hideSpinner(): void {
    this.$('.sequence-search-wrapper .spinner').addClass('hidden');
  }

  showNoResultsMessage(): void {
    const $els = [
      $(
        this.messageRowTemplate({
          message: 'No matches found',
        })
      ),
    ];
    this.$('.search-results').empty().append($els);
    this.$('.search-results').show();
  }

  updateSearchResults(): void {
    this.hideSpinner();
    if (this.sequenceResults.length === 0) {
      this.showNoResultsMessage();
      return;
    }
    const $els = this.sequenceResults.map((sequence) =>
      $(
        this.resultRowTemplate({
          name: sequence.get('name'),
          path: this._getSequencePath(sequence),
        })
      ).data('result', sequence)
    );
    this.$('.search-results').empty().append($els);
    this.$('.search-results').show();
  }

  _getSequencePath(sequence: SequenceSearchResult): string {
    return `${sequence.get('owner')}/${sequence.folder().name}`;
  }

  handleSearchInput(e: JQueryEventObject): void {
    this.showSpinner();
    this.performSearch($(e.target).val());
  }

  fetchResults(query: string): [JQueryXHR] | [JQueryXHR, JQueryXHR] {
    return [this.sequenceResults.fetch({data: {q: query}})];
  }

  displaySearchResults(e: JQueryEventObject): void {
    // Show search result if mousedown inside search wrapper.
    this.$('.search-results').toggle(this.$(e.target).length > 0);
  }

  focus(): void {
    this.$('.search-input').focus();
  }

  setInputValue(val: string): void {
    this.$('.search-input').val(val);
  }

  clearSearch(): void {
    this.$('.search-input').val('');
    this.$('.search-results').empty();

    if (this.alwaysDisplayResults) {
      this.showNoResultsMessage();
    }
  }

  selectResult($target: JQuery): void {
    const sequence = $target.data('result');
    if (this.clearSearchAfterClick) {
      this.clearSearch();
    }
    this.selectSequence(sequence);
  }

  selectResultOnClick(e: JQueryEventObject): void {
    const $target = $(e.currentTarget);
    this.selectResult($target);
  }

  selectResultOnEnter(e: JQueryEventObject): void {
    if (e.which !== 13) {
      return;
    }
    e.preventDefault();
    const $item = this.$('.search-results a.list-group-item').first();
    if ($item.length === 0) {
      return;
    }
    this.selectResult($item);
  }

  escapeSearch(e: JQueryEventObject): void {
    if (keyboard.isEscapeKey(e) && this.$('.search-input').val()) {
      // If this search view is embedded in a modal, prevent the modal from closing
      e.stopPropagation();
      this.clearSearch();
    }
  }

  override render(): this {
    this.$el.html(this.template({searchLibrary: false}));
    if (this.alwaysDisplayResults) {
      this.showNoResultsMessage();
    }
    return this;
  }
}
SequenceSearchView.initClass();

export default SequenceSearchView;
